/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'calendar': {
    width: 64,
    height: 64,
    viewBox: '0 0 64 64',
    data: '<g _fill="none" fill-rule="evenodd"><g _stroke="#000" stroke-width="2" transform="translate(2 2)"><path pid="0" d="M.292 15.792h59.417v43.917H.292zM27.699 6.23l-10.445 9.293m15.314-9.52l10.178 9.52"/><circle pid="1" cx="30" cy="3.905" r="3.287"/><path pid="2" d="M.292 23.542h59.416M10.772 51.829h2.415m5.443 0h2.415m5.17 0h2.414m5.336 0h2.415m-25.608-5.167h2.415m5.443 0h2.415m5.17 0h2.414m5.336 0h2.415m5.336 0h2.415m5.336 0h2.415m-41.11-5.167h2.415m5.443 0h2.415m5.17 0h2.414m5.336 0h2.415m5.336 0h2.415m5.336 0h2.415m-41.11-5.167h2.415m5.443 0h2.415m5.17 0h2.414m5.336 0h2.415m5.336 0h2.415m5.336 0h2.415M33.965 31.16h2.415m5.336 0h2.415m5.336 0h2.415"/></g><path pid="3" d="M1 1h62v62H1z"/></g>'
  }
})
